"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.chainById = void 0;
const starknet_1 = require("starknet");
/** Returns a chain information from its id. */
function chainById(chainId) {
    return KNOWN_CHAINS[chainId];
}
exports.chainById = chainById;
const KNOWN_CHAINS = {
    [starknet_1.constants.StarknetChainId.SN_MAIN]: {
        id: starknet_1.constants.StarknetChainId.SN_MAIN,
        name: 'Starknet Mainnet',
        testnet: false,
    },
    [starknet_1.constants.StarknetChainId.SN_GOERLI]: {
        id: starknet_1.constants.StarknetChainId.SN_GOERLI,
        name: 'Starknet Görli',
    },
    [starknet_1.constants.StarknetChainId.SN_GOERLI2]: {
        id: starknet_1.constants.StarknetChainId.SN_GOERLI2,
        name: 'Starknet Görli 2',
    },
};
//# sourceMappingURL=network.js.map